interface UseCaseTrigger {
  _Name: string;
  _Code: string;
}

export interface UseCaseTriggersFromCurrentState {
  currentstate: { _name: string };
  Triggers: UseCaseTrigger[];
}

const IGNORED_TRIGGER_NAMES = new Set([
  "UM_ABORT",
  "RM_TIMEOUT_CHECK",
  "RM_GET_TRIGGERS_FROM_CURRENT_STATE",
  "RM_GET_XSD_BY_TRIGGER_FROM_CURRENT_STATE"
]);

export const logCurrentStateTriggers = (result: UseCaseTriggersFromCurrentState): void => {
  const availableTriggerNames = result.Triggers.filter((trigger) => !IGNORED_TRIGGER_NAMES.has(trigger._Name)).map(
    (trigger) => trigger._Name
  );

  // eslint-disable-next-line no-console -- log de depuracao intencional para inspecao manual de estado/RMs
  console.group(
    `%cEstado atual: %c${result.currentstate._name}`,
    "font-size: 18px; font-weight: bold; color: #10eeee; letter-spacing: 0.5px;",
    "font-size: 18px; font-weight: bold; color: #10eea4; padding: 3px 12px; border-radius: 6px;"
  );

  // eslint-disable-next-line no-console -- log de depuracao intencional para inspecao manual de estado/RMs
  console.log("%cRMs que podem ser chamados:", "font-size: 15px; font-weight: bold; color: #10eeee; margin-top: 4px;");

  availableTriggerNames.forEach((name) => {
    // eslint-disable-next-line no-console -- log de depuracao intencional para inspecao manual de estado/RMs
    console.log(
      `%c▸ %c${name}`,
      "font-size: 15px; color: #10eeee; font-weight: bold;",
      "font-size: 15px; color: #10eea4; font-weight: bold; padding: 2px 8px; border-radius: 4px;"
    );
  });

  // eslint-disable-next-line no-console -- log de depuracao intencional para inspecao manual de estado/RMs
  console.groupEnd();
};
